import { paginatedBedMap } from "@/utils/mappings/bed";
import { transformData } from "@/utils/transformData";
import { useApi } from "./useApi";

export function useBeds() {
	const { api } = useApi();

	async function getSurgicalBeds(
		page: number,
		search: string,
		loadRelations?: boolean,
		filters?: Filters
	) {
		const filtersToApply = Object.fromEntries(
			Object.entries(filters || {}).filter(([_, value]) => value)
		);

		try {
			const { data } = await api.get("surgical-center/beds", {
				params: {
					page,
					load_relations: loadRelations,
					...(search && { search }),
					...filtersToApply,
				},
			});

			return transformData<PaginatedBeds>(data, paginatedBedMap);
		} catch (error) {
			console.log(error);
			return {} as PaginatedBeds;
		}
	}

	return { getSurgicalBeds };
}
